// Importing the default export
globalThis.selectedClasses = "relative flex w-fit cursor-pointer items-center rounded-full border px-2.5 py-1 text-sm leading-tight select-none text-skin-dark border-skin-light bg-skin-lighter font-medium"
globalThis.unselectedClass = "relative flex w-fit cursor-pointer items-center rounded-full border px-2.5 py-1 text-sm leading-tight select-none text-skin-medium hover:text-skin-dark border-transparent";

globalThis.updateFilters = function (element, event) {
    element.parentNode.querySelectorAll(`[data-type="listingboxfilter"]`).forEach((item) => {
        item.classList = unselectedClass;
    })
    element.classList =selectedClasses;
}


globalThis.pushUrl = function (element, event) {

    let link = element.getAttribute("hx-get");
    link = link.split("?")[1];
    let pageParams = new URLSearchParams(window.location.search);
    for (const key of pageParams.keys()) {
       pageParams.delete(key);
    }
    const urlParams = new URLSearchParams(link);
    const prefix = urlParams.get("target");
    const keys = urlParams.keys();

    for (const key of keys) {
        if (key !== "target") {
            pageParams.set("listing:" + prefix + ":" + key, urlParams.get(key));
        }
    }
    if(element.getAttribute("id")){
        pageParams.set("listing:" + prefix + ":selected", element.getAttribute("id"));
    }
    window.history.pushState(null, null, "?" + pageParams);
}

globalThis.pushUrlMeinBereich = function (element, event) {

    // fetch link of current filter
    let link = element.getAttribute("hx-get");
    link = link.split("?")[1];

    // transform into urlparams for better handling
    let urlParams = new URLSearchParams(link);
    const target = urlParams.get("target");
    const keys = urlParams.keys();

    // fetch current url
    const pageParams = new URLSearchParams(window.location.search);

    // set new parameters of activated filters
    for (const key of keys) {
        if (key !== "target") {
            pageParams.set("listing:" + target + ":" + key, urlParams.get(key));
        }
    }
    window.history.pushState(null, null, "?" + pageParams);
}

window.addEventListener("DOMContentLoaded", function (event) {

    const pageParams = new URLSearchParams(window.location.search);
    let node_ids = [];
    for (const key of pageParams.keys()) {
        let node_id = key.split(":")[1] ? key.split(":")[1] : "";
        if (!node_ids.includes(node_id)) {
            node_ids.push(node_id);
        }
    }
    for (const key_selection of node_ids) {
        const selectedItem = pageParams.get("listing:" + key_selection + ":selected");
        if(selectedItem){
            document.getElementById("id_" + key_selection).querySelectorAll(`[data-type="listingboxfilter"]`).forEach((item) => {
                if (item.getAttribute("id") === selectedItem) {
                    item.classList = selectedClasses;
                } else {
                    item.classList = unselectedClass;
                }
            });
        }

    }

})

